import React, { useState } from 'react';
import Input from '~~elements/Input';
import Button from '~~elements/Button';
import { UserResource } from '~~apis/resource';
import IconEmail from './assets/IconEmail.svg';
import { StyledForm } from './Styles';
import { STATUS } from './LoginConsts';

const ForgetPasswordForm = () => {
  const [email, setEmail] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [apiStatus, setApiStatus] = useState('');

  function handleSubmit(e) {
    e.preventDefault();
    setApiStatus('LOADING');

    UserResource.forgetPassword({ email })
      .then(() => {
        setApiStatus('SUCCESS');
      })
      .catch((error) => {
        return handleError(error.message);
      });
  }

  function handleInputOnchange(e) {
    if (errorMsg) {
      setErrorMsg('');
    }

    setEmail(e.target.value);
  }

  function handleKeyPress(e) {
    if ('Enter' !== e.key) {
      return;
    }

    e.preventDefault();
    if (handleCheckDisabled()) {
      return;
    }

    return handleSubmit(e);
  }

  function handleError(errorCode) {
    const status = 'ERROR';
    setApiStatus(status);
    let errorMessage = '發生錯誤，請稍後再試，或與我們聯絡。';
    switch (errorCode) {
      case 'USER_NOT_FOUND':
        errorMessage = '此信箱尚未註冊';
        break;
      case 'INVALID_FORMAT':
        errorMessage = '格式錯誤';
        break;
      default:
        break;
    }
    setErrorMsg(errorMessage);
  }

  function handleCheckDisabled() {
    return !email || apiStatus === 'LOADING' || apiStatus === 'SUCCESS';
  }

  return (
    <StyledForm onSubmit={(e) => handleSubmit(e)} autoComplete="off" status={STATUS.SIGN_IN}>
      <div className="upper-box">請輸入信箱以發送重設密碼連結</div>
      <div className="bottom-box">
        {/* 信箱 */}
        <div className="input-field">
          <img src={IconEmail} alt="Email" />
          <Input
            placeholder="信箱"
            name="email"
            onChange={handleInputOnchange}
            onKeyPress={handleKeyPress}
            value={email}
            disabled={apiStatus === 'SUCCESS'}
          />
        </div>
        <div className="error-msg">{errorMsg && errorMsg}</div>
        <Button boxShadow round width="50%" type="submit" disabled={handleCheckDisabled()}>
          送出
        </Button>
        {apiStatus === 'SUCCESS' && (
          <div className="normal-msg">已發送密碼重設連結至信箱，請於一小時內點擊進行重設</div>
        )}
      </div>
    </StyledForm>
  );
};

export default ForgetPasswordForm;
